import { Employee } from "@/models/employees";
import store from "@/store";
import { AbstractJSONModel } from "@/models/master-model";
import { Type } from "class-transformer";
import { addMonths, subYears } from "date-fns";
import { eSalerySystem, Institution } from "../../../models/institution-model";

export enum eRole {
  Manager = 1,
  Employee = 2
}

export enum eLoginType {
  USERNAME_PASSWORD = "username_password",
  DI = "DI",
  UNILOGIN = "Unilogin",
  FKA = "FKA",
  AULA = "Aula"
}

export interface IUserActivation {
  date: Date;
  mailToken: string;
  accessToken: string;
  institutionName: string;
  code: number;
}

export interface IUserPut {
  id: number;
  email_address: string;
}

export interface IUser {
  id: number;
  created_at: Date | null;
  selectable_institutions: { id: number; code: number; name: string; role: number }[];
  selected_institution: { id: number; code: number; name: string; role: number } | undefined;
  username: string;
  login_type: eLoginType | undefined;
  email_address: string;
  // Understående er ikke med i login_openid response

  institutioner: Institution[];
  cell_phone: string;

  employee_id: number | null;
  municipality_id: number;
  news_read_at: Date | null;
  password_last_changed: Date | null;
  updated_at: Date | null;

  wants_advice: boolean;
  SelectedInstitutionId: number;
  errors: string;
}

export class User extends AbstractJSONModel implements IUser {
  created_at: Date | null = null;
  id = -1; // dto_user_id
  selectable_institutions: {
    id: number;
    code: number;
    name: string;
    role: eRole;
    web_access_is_read_only: boolean;
  }[] = [];
  selected_institution:
    | {
        id: number;
        code: number;
        name: string;
        role: eRole;
        web_access_is_read_only: boolean;
        so_calculates_as: number;
        salary_system: eSalerySystem;
        g_number: string;
      }
    | undefined = undefined;
  username = "";
  login_type: eLoginType | undefined = undefined;
  employee_id: number | null = null;
  email = "";
  email_address = "";
  errors = "";

  // Understående er ikke med i login_openid response

  institutioner: Institution[] = [];
  cell_phone = "";
  municipality_id = 0;
  news_read_at: Date | null = null;
  @Type(() => Date)
  password_last_changed: Date | null = null;
  updated_at: Date | null = null;

  wants_advice = false;
  SelectedInstitutionId = 0;

  dutiesTo;

  employmentsFrom() {
    return subYears(new Date(), 1);
  }

  employmentsTo(toDate: Date) {
    const oneMonthFromToday = addMonths(new Date(), 1);
    const employee = this.employee();
    const currentEmployment = employee?.employment(new Date());
    if (currentEmployment && currentEmployment.end_date < toDate) {
      const employmentOneMonthFromNow = employee?.employment(oneMonthFromToday);
      if (employmentOneMonthFromNow) {
        return employmentOneMonthFromNow.end_date;
      } else {
        return currentEmployment.end_date;
      }
    } else {
      return toDate > oneMonthFromToday ? toDate : oneMonthFromToday;
    }
  }

  isManager() {
    return this.selected_institution?.role === eRole.Manager;
  }

  isEmployee() {
    return this.selected_institution?.role === eRole.Employee;
  }

  employee(): Employee | undefined {
    const employee = store.getters["employees/GetEmployeeById"](this.employee_id);
    return employee;
  }

  shortname(name: string): string {
    return name
      ? Array.prototype.map
          // eslint-disable-next-line space-before-function-paren
          .call(name.split(" "), function (x: string): string {
            return x.substring(0, 1).toUpperCase();
          })
          .join("")
      : "";
  }

  public convertToPutObject(): IUserPut {
    const u: IUserPut = Object.assign({});
    u.id = this.id;
    u.email_address = this.email_address;
    return u;
  }
}
